import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromReportState from './report.state';

export const getReportState = createFeatureSelector<fromReportState.ReportState>(fromReportState.featureKey);

/** Select reports. */
export const selectReports = createSelector(getReportState, state => state.reports);
